<template>
  <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.9961 7.99805L15.3294 11.3314L11.9961 14.6647" stroke="#0017A8" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M0.664062 11.332L15.3307 11.332" stroke="#0017A8" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M3.9974 7.9987L0.664062 4.66536L3.9974 1.33203" stroke="#0017A8" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M0.664062 4.66602L15.3307 4.66602" stroke="#0017A8" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
